import { CarrierRowActions } from 'modules/inventory/provider/carriers/components/CarrierRowActions';
import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { addressColumn, createdATColumn } from 'modules/common/constants/common.columns';
import { CARRIER_PERMISSIONS } from 'modules/inventory/provider/carriers/constants/carrier.permissions';
import {
  providerEmailColumn,
  providerPhoneColumn,
} from 'modules/inventory/provider/common/constants';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { CarrierStatusPicker } from '../components/CarrierStatusPicker';
import { ICarrier } from '../interfaces';
import { LOGISTICS_PERMISSIONS } from '../../logistics/constants';

export const carrierOnlyNameColumn: HeadCell = {
  field: 'name',
  headerName: 'product:fields.name',
  renderCell: (name: string, data: ICarrier) => (
    <AvatarNameCell link={`/inventory/provider/carriers/${data?._id as string}/general`} hideImage name={data.name} />
  ),
};

export const carrierStatusColumn: HeadCell<ICarrier> = {
  field: 'active',
  headerName: 'common:fields.visible.title',
  align: CellAlign.CENTER,
  renderCell: (active: boolean, data: ICarrier) => (
    <CarrierStatusPicker
      rowId={data._id as string}
      value={active}
      record={data}
      permissions={CARRIER_PERMISSIONS.CARRIER_WRITE}
    />
  ),
};

export const carrierActionsColumn: HeadCell<ICarrier> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: CARRIER_PERMISSIONS.CARRIER_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  renderCell: (_, carrier) => <CarrierRowActions carrier={carrier} />,
};

export const carrierNameConciliationColumn: HeadCell = {
  field: 'name',
  headerName: 'product:fields.name',
  renderCell: (name: string, data: ICarrier) => (
    <AvatarNameCell link={`/conciliations/main/carriers/${data?._id as string}`} hideImage name={data?.name} />
  ),
};

export const logisticsNameColumn: HeadCell<ICarrier> = {
  field: 'logistic.name',
  headerName: 'common:logisticProvider',
  disablePadding: false,
  renderCell: (name: string, data: ICarrier) => (
    <AvatarNameCell
      name={name}
      link={`/inventory/provider/logistics/${data?.logistic?._id as string}/general`}
      hideImage
      permissions={LOGISTICS_PERMISSIONS.LOGISTICS_VIEW}
    />
  ),
};

export const carrierColumns: Array<HeadCell<any>> = [
  carrierOnlyNameColumn,
  logisticsNameColumn,
  providerEmailColumn,
  providerPhoneColumn,
  addressColumn,
  carrierStatusColumn,
  createdATColumn,
  carrierActionsColumn,
];

export const carrierConciliationsColumns: Array<HeadCell<any>> = [
  carrierNameConciliationColumn,
  providerEmailColumn,
  providerPhoneColumn,
  addressColumn,
  carrierStatusColumn,
  createdATColumn,
];
